import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { getMisSubmittedForverificationAPI } from '../../../services/mis-service';

import {
    FETCH_SUBMITTED_FOR_VERIFICATION,
    FETCH_SUBMITTED_FOR_VERIFICATION_START,
    FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS,
    FETCH_SUBMITTED_FOR_VERIFICATION_ERROR,
    SET_MIS_SFV_FILTER,
    SET_SFV_PAGINATION
} from "../../actions/mis/submittedForVerificationAction";

function* fetchSubmittedForVerificationVisits({ payload }) {
    try {
        yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_START })
        const response = yield call(getMisSubmittedForverificationAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS, submittedForVerification: response.data.misSubmittedForVerification });
            yield put({ type: SET_SFV_PAGINATION, pagination });
            yield put({ type: SET_MIS_SFV_FILTER, payload: { ...payload } });
        } else {
            yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_ERROR, error: response.error })
            message.error('Failed to fetch review pending reports!');
        }
    } catch (error) {
        yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_ERROR, error })
        message.error('Failed to fetch review pending reports!');
    }
}

function* submittedForVerificationWatcher() {
    yield takeEvery(FETCH_SUBMITTED_FOR_VERIFICATION, fetchSubmittedForVerificationVisits)
}

export default function* rootSaga() {
    yield all([
        submittedForVerificationWatcher(),
    ]);
}